// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.

/** Jargon → plain-English definitions, surfaced as click-to-define tooltips. */
export const GLOSSARY: Record<string, string> = {
  dithering:
    'Faking colours a limited palette does not have by scattering the ones it does. From a normal viewing distance the specks blend into the missing shade.',
  'error diffusion':
    'A family of dithering (Floyd–Steinberg, Atkinson, Stucki…) that pushes each pixel’s rounding error onto its not-yet-drawn neighbours, so mistakes cancel out across the image.',
  'floyd–steinberg':
    'The classic error-diffusion dither from 1976 — a good, general-purpose default that looks natural on photos.',
  atkinson:
    'Bill Atkinson’s dither from the original Macintosh. It only spreads part of the error, giving a crisper, higher-contrast look.',
  ordered:
    'Ordered (Bayer) dithering compares each pixel against a fixed repeating threshold grid. It is fast and gives a regular cross-hatch, newsprint-like texture.',
  '1-bit':
    'One bit per pixel — just black or white, no grey. The format of e-ink screens, thermal printers and classic Mac art.',
  palette: 'The fixed set of colours the output is allowed to use. Everything is mapped onto it.',
  'median cut':
    'A way to pick a small palette straight from your image: repeatedly split the cloud of colours in half until you have the number you asked for, then average each group.',
  'pixel size':
    'How many source pixels are grouped into one chunky art pixel before dithering. Larger means blockier, more pixel-art; 1 keeps full detail.',
  serpentine:
    'Scanning alternate rows right-to-left (“boustrophedon”) so error-diffusion artefacts do not all lean the same way.',
};
